import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/collapse";

import SideBarMenuStikcy from "design-system/resources/html/components/common/sidebar/sidebar";

import Header from "design-system/resources/html/components/common/header/header";
import NavbarMobile from "design-system/resources/html/components/common/navbar-mobile/navbar-mobile";

import Table from "design-system/resources/html/components/platforms/table/table";

import RiskWarningBar from "design-system/resources/html/components/common/risk-warning-bar/risk-warning-bar";

import getIdCarouselForGlideSlide from './glide';
import addItemSessionStorage from "./addItemSessionStorage";
import mParticleLogEvent from "./mParticleLogEvent";
import ibFormHelperFunc from "./ib-form";

window.onload = function () {
  Header();
  NavbarMobile();  
  RiskWarningBar();
  Table();
  mParticleLogEvent();
  getIdCarouselForGlideSlide();
  addItemSessionStorage();
  SideBarMenuStikcy();
};

(function (Drupal) {
  Drupal.behaviors.ib_form = {
    attach: function(context, settings) {
      ibFormHelperFunc();
    }
  };
})(Drupal);